module.exports = __webpack_public_path__ + "media/assets/avia/search/plane_second_blue-3f1ae558675154bfc47680d53a13bd7a.png";